// frontend/src/utils/money.ts
//
// 金额展示统一工具：后端金额一律为最小货币单位（分），
// 展示时统一 分→元 保留两位小数并带币种。

/** 分 → "12.34 USD" */
export function formatAmount(amount: number | undefined | null, currency?: string): string {
  const value = ((amount || 0) / 100).toFixed(2);
  return currency ? `${value} ${currency.toUpperCase()}` : value;
}

/** 分 → 货币符号格式（如 $12.34），失败时回退 formatAmount */
export function formatMoney(amount: number | undefined | null, currency: string = 'USD'): string {
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: (currency || 'USD').toUpperCase(),
    }).format((amount || 0) / 100);
  } catch {
    return formatAmount(amount, currency);
  }
}

/** 元（用户输入）→ 分（API 入参） */
export function yuanToCents(value: number | string | undefined | null): number {
  const n = typeof value === 'string' ? parseFloat(value) : value || 0;
  if (!n || Number.isNaN(n)) return 0;
  return Math.round(n * 100);
}

/**
 * 防御性数组：后端列表接口在无数据时可能返回 null/undefined/对象，
 * 统一兜底为数组，避免 Table dataSource 或 .map/.reduce 崩溃。
 */
export function safeArray<T = any>(value: any): T[] {
  return Array.isArray(value) ? value : [];
}
